import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaShieldAlt, FaUsers, FaDollarSign, FaBell, FaHeadset, FaIdCard, FaChevronRight, FaList, FaChartBar } from 'react-icons/fa';
import LiveMapSection from '../LiveMapSection';
import Motivation from '../Motivation';
import BottomSheet from '../../UI/BottomSheet';
import AdminDashboard from '../../ADMIN/AdminDashboard';

const AdminView = ({
    pickupPos, dropoffPos, handleMapClick, selectedDriver, setSelectedDriver, clearPositions
}) => {
    const navigate = useNavigate();
    const [sheetExpanded, setSheetExpanded] = useState(false);

    return (
        <div className="dv-figma-container">
            {/* ── Vista Escritorio: Dashboard Empresarial directo ── */}
            <div className="d-none d-lg-block py-2">
                <AdminDashboard navigate={navigate} />
            </div>

            {/* ── Vista Móvil: Mapa interactivo + BottomSheet con zIndex contenido ── */}
            <div className="d-lg-none">
                <div className="dv-map-wrapper">
                    <div className="position-absolute top-0 start-0 m-2" style={{ zIndex: 10 }}>
                        <span className="badge rounded-pill bg-dark bg-opacity-75 text-white px-3 py-2 shadow-sm d-flex align-items-center gap-2" style={{ backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.15)', fontSize: '0.78rem' }}>
                            <FaShieldAlt className="text-info" /> Administración
                        </span>
                    </div>
                    <LiveMapSection 
                        pickupPos={pickupPos} 
                        dropoffPos={dropoffPos} 
                        handleMapClick={handleMapClick} 
                        selectedDriver={selectedDriver} 
                        setSelectedDriver={setSelectedDriver} 
                        clearPositions={clearPositions} 
                    />
                </div>

                <BottomSheet
                    title="Panel de Administración"
                    date={new Date().toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'short' })}
                    defaultExpanded={sheetExpanded}
                    onToggle={setSheetExpanded}
                    className="dv-tasks-bottom-sheet"
                >
                    <div className="mb-3">
                        <Motivation />
                    </div>

                    {/* Acciones Rápidas */}
                    <div className="bry-section-header">Acciones Rápidas</div>
                    <div className="dv-stats-grid mb-3">
                        <div className="bry-stat-card" onClick={() => navigate('/admin')} style={{ cursor: 'pointer', padding: '12px' }}>
                            <div className="bry-stat-icon accent"><FaShieldAlt size={18} /></div>
                            <div>
                                <div className="bry-stat-label">Panel</div>
                                <div className="bry-stat-value" style={{ fontSize: '14px' }}>Admin</div>
                            </div>
                        </div>
                        <div className="bry-stat-card" onClick={() => navigate('/admin/users')} style={{ cursor: 'pointer', padding: '12px' }}>
                            <div className="bry-stat-icon success"><FaUsers size={18} /></div>
                            <div>
                                <div className="bry-stat-label">Gestión</div>
                                <div className="bry-stat-value" style={{ fontSize: '14px' }}>Usuarios</div>
                            </div>
                        </div>
                        <div className="bry-stat-card" onClick={() => navigate('/admin/pagos')} style={{ cursor: 'pointer', padding: '12px' }}>
                            <div className="bry-stat-icon warning"><FaDollarSign size={18} /></div>
                            <div>
                                <div className="bry-stat-label">Revisión</div>
                                <div className="bry-stat-value" style={{ fontSize: '14px' }}>Pagos</div>
                            </div>
                        </div>
                    </div>

                    {/* Herramientas */}
                    <div className="bry-section-header">Herramientas</div>
                    <div className="bry-menu-list mb-3">
                        <Link to="/admin" className="bry-menu-item"><FaShieldAlt /> Panel Administrador <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                        <Link to="/admin/pagos" className="bry-menu-item"><FaDollarSign /> Conciliación Pagos <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                        <Link to="/admin/users" className="bry-menu-item"><FaUsers /> Gestionar Usuarios <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                        <Link to="/notificaciones" className="bry-menu-item"><FaBell /> Notificaciones <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                        <Link to="/soporte" className="bry-menu-item"><FaHeadset /> Tickets Soporte <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                        <Link to="/historial-servicios" className="bry-menu-item"><FaList /> Historial Servicios <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                        <Link to="/graph-panel" className="bry-menu-item"><FaChartBar /> Gráficos <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                        <Link to="/perfil" className="bry-menu-item"><FaIdCard /> Mi Perfil <FaChevronRight size={12} style={{ marginLeft: 'auto', color: 'var(--bry-text-tertiary)' }} /></Link>
                    </div>
                </BottomSheet>
            </div>
        </div>
    );
};

export default AdminView;
